var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVouchersYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E5B909",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M26.1881 21.1282V18.6034C25.6925 18.6034 25.2814 18.2041 25.2814 17.7226V14.7163C25.2814 14.3159 24.955 14 24.544 14H16.2389C13.6277 14 11.5 16.0656 11.5 18.6034V21.6437C11.5 21.8797 11.5967 22.1029 11.766 22.2673C11.9352 22.4305 12.1649 22.5245 12.4067 22.5245C13.3254 22.5245 14.0266 23.1586 14.0266 23.9924C14.0266 24.8625 13.3133 25.5554 12.4188 25.566C11.9231 25.566 11.5 25.9065 11.5 26.3997V29.4072C11.5 31.9437 13.6277 33.9988 16.2268 33.9988H24.544C24.955 33.9988 25.2814 33.6806 25.2814 33.2825V30.7448C25.2814 30.2527 25.6925 29.864 26.1881 29.864V27.587C25.6925 27.587 25.2814 27.1865 25.2814 26.7062V22.0089C25.2814 21.5274 25.6925 21.1282 26.1881 21.1282Z",
    fill: "#E5B910"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9728 23.9935C33.9728 24.8625 34.6981 25.5554 35.5806 25.5671C36.0763 25.5671 36.4994 25.9077 36.4994 26.3892V29.4072C36.4994 31.9449 34.3838 34 31.7726 34H27.8316C27.4327 34 27.0942 33.6818 27.0942 33.2825V30.7459C27.0942 30.2527 26.6952 29.8652 26.1875 29.8652V27.5882C26.6952 27.5882 27.0942 27.1877 27.0942 26.7074V22.0101C27.0942 21.5274 26.6952 21.1294 26.1875 21.1294V18.6034C26.6952 18.6034 27.0942 18.2041 27.0942 17.7226V14.7175C27.0942 14.3171 27.4327 14 27.8316 14H31.7726C34.3838 14 36.4994 16.0551 36.4994 18.5916V21.5509C36.4994 21.7858 36.4027 22.0101 36.2334 22.1733C36.0642 22.3377 35.8345 22.4317 35.5927 22.4317C34.6981 22.4317 33.9728 23.1375 33.9728 23.9935Z",
    fill: "#E5B910"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVouchersYellow);
export default __webpack_public_path__ + "static/media/vouchers-yellow.308fedaeb0426205773d2826060ee317.svg";
export { ForwardRef as ReactComponent };